import React from "react";

export default function Courseview() {
  return (
    <div>Atölye Görüntüleme Sayfası Çalışma Aşamasında Lütfen Bekleyin...</div>
  );
}
